import {useTranslation} from "react-i18next";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {permissionObj} from "../../../../../../../Helpers/permission";
import {useEffect, useState} from "react";

import HandleChange from "../../../../../../../Helpers/HandleChange";
import {DEFAULT_LATITUDE, DEFAULT_LONGITUDE, deviceListToLabel, errorMsg} from "../../../../../../../Apis/functions";
import {toast} from "react-toastify";
import routes from "../../../../../../../Routes/routes";
import {ATTENDANCE_GEOFENCES_MODEL, isCloseTimeNotValid} from "../Model/Model";
import {
    GetGeofenceById,
    UpdateGeofence
} from "../../../../../../../reduxToolkit/AttendanceGeofence/AttendanceGeofenceApi";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 23 de 01 de 2026
 */
export const UpdateGeofenceAttendanceApp = () => {
    const {t} = useTranslation();
    const {id} = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const {state} = location;
    const [selectedList, setSelectedList] = useState([]);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const [emptyFields, setEmptyFields] = useState(false);
    const [geofences, setGeofences] = useState([]);
    const [item, setItem] = useState({...ATTENDANCE_GEOFENCES_MODEL});
    const [dayArray, setDayArray] = useState([]);
    const {handleChange} = HandleChange({model: item, setModel: setItem});
    const [latitude, setLatitude] = useState(DEFAULT_LATITUDE);
    const [longitude, setLongitude] = useState(DEFAULT_LONGITUDE);
    const [center, setCenter] = useState(null);
    const isCloseTimeInvalid = isCloseTimeNotValid(item.opening, item.closing);
    useEffect(() => {
        setItem(prev => ({ ...prev, devices: selectedList }));
    }, [selectedList]);

    /**
     * Sync the geofence model and dayArray whenever zones change.
     * Ensures the UI form reflects the current zones.
     */
    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        dispatch(GetGeofenceById(id)).then(({payload: {data: {data, success, code}}}) => {
            if (success) {
                setItem(ATTENDANCE_GEOFENCES_MODEL.toSet(data));
                setSelectedList(deviceListToLabel(data?.attendanceGeofenceConfigDto?.devices));
                const aux = {...ATTENDANCE_GEOFENCES_MODEL.toSetMap(data, setDayArray)};
                setGeofences([aux]);
                let center = ATTENDANCE_GEOFENCES_MODEL.getGeofenceCenter(aux);
                if (center) {
                    setCenter(center);
                }
            } else {
                errorMsg(code);
            }
        });
    }
    /**
     * Handle update submission of the geofence.
     * Validates required fields and schedule before generating the payload.
     */
    const handleUpdate = () => {
        if (!item.isValidDetails() || !item.isValidSchedule(dayArray) || !item.isValidArea(geofences)) {
            setEmptyFields(true);
            toast.warning(t('please_fill_all_fields'));
            return;
        }

        setEmptyFields(false);
        dispatch(UpdateGeofence(item.toRegister(geofences[0].coordinates, dayArray)))
            .then(({payload: {data: {success, code}}}) =>
            {
                if (success) {
                    toast.success(t('has_been_updated_successfully'));
                    getData();
                }
                else {
                    errorMsg(code);
                }
        });
    };

    const handleOnBack = () => {
        navigate(
            routes.attendance.main, {
                state: state
            });
    }

    return {
        DEV,
        permission,
        t,
        item,
        emptyFields,
        setItem,
        setDayArray,
        dayArray,
        handleChange,
        geofences,
        setGeofences,
        latitude,
        setLatitude,
        longitude,
        setLongitude,
        center,
        handleUpdate,
        handleOnBack,
        isCloseTimeInvalid,
        selectedList,
        setSelectedList
    };
};
